import { useQuery } from "react-query";
import { getEmploymentType } from "../../../../../actions/Utilities/EmploymentType";

export default function useEmploymentType() {
  const {data, isFetching} = useQuery("GetEmploymentType", getEmploymentType, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
